var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnippet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    fill: "none",
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.8374 0L14.8104 0.135653L10.4626 19.266L10.2991 20H12.9896L13.0165 19.8642L17.3643 0.733913L17.5278 0H14.8374ZM8.69565 2.6087L8.3426 2.88087L0.516512 8.96783L0 9.37564V10.6261L0.516512 11.0339L8.3426 17.1208L8.69565 17.3931V14.1052L3.42348 10.0017L8.69565 5.89826V2.61043V2.6087ZM19.1304 2.6087V5.89653L24.4027 10L19.1304 14.1035V17.3913L19.4834 17.1192L27.3095 11.0322L27.8261 10.6243V9.37391L27.3095 8.96608L19.4834 2.87913L19.1304 2.60695V2.6087Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnippet);
export default __webpack_public_path__ + "static/media/snippet.8175e4140b359c201c68fbac0acb3e27.svg";
export { ForwardRef as ReactComponent };